import { curry } from 'ramda';
import { SocialLinkTypes } from '../../custom-types/footer';
import { LinkWeb, toLink } from '../../fields/link';

const socialNetwork = (
  type: SocialLinkTypes,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): SocialNetwork | undefined => {
  const link = toLink(data?.primary?.link) as LinkWeb;
  if (!link) {
    return undefined;
  }
  return {
    type,
    link,
  };
};

export type SocialNetwork = {
  type: SocialLinkTypes;
  link: LinkWeb;
};

export default curry(socialNetwork);
